<template>
<v-container></v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'

export default {
  name: 'Login',
  methods: {
    login() {
      let provider = new firebase.auth.GoogleAuthProvider();
      provider.setCustomParameters({
        prompt: 'select_account'
      });
      this.$auth.signInWithRedirect(provider);
      this.$auth.getRedirectResult().then(() => {
        this.redirect();
      }).catch(function(error) {
        let errorCode = error.code;
        let errorMessage = error.message;
        let email = error.email;
        console.log('ERROR', errorCode, errorMessage, email);
      });
    },
    redirect() {
      this.$emit('progress', false);
      this.$router.replace(this.$route.query.redirect || '/');
    }
  },
  mounted() {
    this.$emit('progress', true);
    let unsubscribe = this.$auth.onAuthStateChanged(user => {
      unsubscribe();
      if (user) {
        this.redirect();
      } else {
        this.login();
      }
    })
  }
}
</script>
